<script setup lang="ts">
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons'
</script>

<template>
  <GButton
    name="back-button"
    variant="secondary"
    class="g-back-button flex-shrink-0"
    iconSize="md"
    :icon="faChevronLeft"
  />
</template>
